import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { environment } from 'environments/environment';
import { DialogService } from '@common/services/dialog.service';
import { VesselNotificationPermissions } from '@common/classes/permissions';
import { AutoFilterBreezeListComponent } from '@common/classes/auto-filter-list';
import { UploadActionButtonsComponent } from '@common/components/upload-action-buttons.component';
import { HttpClient } from '@angular/common/http';
import _ from 'lodash';
import { UploadVesselNotificationModalComponent } from '../../../vessel-notification/components/upload-vessel-notification-modal/upload-vessel-notification-modal.component';
import { VesselShortNotificationGridComponent } from '../vessel-short-notification-grid/vessel-short-notification-grid.component';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-vessel-short-notification-list',
    templateUrl: './vessel-short-notification-list.component.html',
    styleUrls: ['./vessel-short-notification-list.component.scss'],
    providers: [BreezeViewService],
    encapsulation: ViewEncapsulation.None
})
export class VesselShortNotificationListComponent extends AutoFilterBreezeListComponent implements OnInit {
    queryName = 'VesselNotifications';
    createPermission = VesselNotificationPermissions.Action.create;
    exportCommand = 'ExportVesselShortNotifications';
    selectedTabIndex = 0;

    @ViewChild(VesselShortNotificationGridComponent) vesselShortNotificationGrid;

    breadcrumb = [
        {
            icon: 'ship',
            title: 'Short Vessel Notifications'
        }
    ];

    constructor(protected breezeViewService: BreezeViewService,
        private dialogService: DialogService,
        private http: HttpClient) {
        super(breezeViewService);

        this.actionBar[0].items.push({
            label: 'Upload',
            icon: 'book',
            isVisible: () => this.user?.hasPermission(VesselNotificationPermissions.Action.upload),
            onClick: () => this.upload(),
        });

        this.actionBar[0].items.push({
            label: 'Download template',
            icon: 'file-excel',
            isVisible: () => this.user?.hasPermission(VesselNotificationPermissions.Action.upload),
            onClick: () => this.downloadTemplate(),
        });
    }

    override ngOnInit() {
        this.filter = super.getFilter();
        this.filter.archived = this.selectedTabIndex === 1;
        this.initialize();
    }

    async downloadTemplate() {
        const excelFileName = environment.shortExcelTemplateFile;
        const attachment = await firstValueFrom(this.http.get(`${window.location.protocol}/assets/documents/${excelFileName}`, {
            responseType: 'blob'
        }));
        UploadActionButtonsComponent.downloadBlob(excelFileName, attachment);
    }

    async upload() {
        const data = await this.dialogService.open(UploadVesselNotificationModalComponent, { size: 'md' });
        if (!data) return;

        const res = await this.breezeViewService.executeCommand('UploadVesselShortNotification', {
            content: data.file.content,
            fileName: data.file.name,
            agentId: data.agentId,
            dutyNumber: data.dutyNumber
        }, true, true)
            .finally(() => this.isBusy = false);
        if (!res) return;

        this.router.navigate([`short-vessel-notification/view/${res.results[0]}`]);
    }

    override getDefaultFilter() {
        return {
            isShort: true,
            archived: this.selectedTabIndex === 1
        };
    }

    override canExportPdf() {
        return false;
    }

    override export(exportType) {
        return super.export(exportType, this.vesselShortNotificationGrid.appGrid);
    }

    searchBy(data: any) {
        if (data.propertyName === 'vesselId')  this.filter = this.getDefaultFilter();
        this.filter[data.propertyName] = data.value;
        this.search();
    }

    onTabSelect(tab) {
        this.selectedTabIndex = tab.index;
        this.filter.archived = tab.index === 1;
        this.search();
    }
}
